/**
 * Shared MathLive loader. When the returned promise resolves, the library is loaded
 * and window.mathVirtualKeyboard is available. Use this from MathFieldInput and
 * useMathVirtualKeyboard so both subscribe to the same ready signal.
 */
let mathLiveReady: Promise<void> | null = null;

/**
 * Loads MathLive on first call and returns the same promise on subsequent calls.
 * Resolves when the library is ready and window.mathVirtualKeyboard is available.
 * No-op (resolves immediately) when not in a web environment.
 */
export function ensureMathLive(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve();
  if (!mathLiveReady) {
    mathLiveReady = import("mathlive").then(({ MathfieldElement }) => {
      MathfieldElement.fontsDirectory = "/mathlive-fonts/";
    });
  }
  return mathLiveReady;
}
